export default __webpack_public_path__ + "static/media/portfolio-bg.a6e4ff29.png";